import React, { useState, useEffect, MouseEvent, } from "react";

import styled from "styled-components";
import SimpleButton from "../../../../../components/GlobalButtons/SimpleButton";
import GlobalModal from "../../../../../components/GlobalModal";
import Input from "../../../../../components/Input";
import { FlexBox } from "../../../../../statics/styles/StyledComponents";
import {
  Form,
  Row,
  Col,
  Divider,
  message,
} from "antd";
import { convertDateAndTime, getBizCode } from "utilities/Functions/GlobalHelperFunctions";
import { InfoCircleOutlined } from "@ant-design/icons";
import AdiTable from "components/AdiTable";
import CustomField, { CustomFieldType } from "../../components/CustomField";
import DragFileInput from "components/Input/DragFileInput";
import { useFileUpload } from "utilities/hooks";
import { emptyAssetDataBulk } from ".";
import { ASSET_MANAGEMENT_API } from "utilities/AdiApi";
import { useGeneralStore } from "zustand-stores";
import { GeneralStore } from "zustand-stores/useGeneralStore";
import { RcFile } from "antd/es/upload/interface";

type Props = {
  isModalOpenBulk: boolean;
  setIsModalOpenBulk: Function;
  assetDataBulk: any;
  setAssetDataBulk: Function;
  handleSelectAssetPreset: (value: string, isBulk: boolean) => void;
  validateMessages: any;
  renderOption: (key: string) => any;
  alertPresetColumns: any;
  maintenanceRulesColumns: any;
  initialize: Function;
}

const BulkAssetModal = (props: Props) => {
  const {
    isModalOpenBulk,
    setIsModalOpenBulk,
    assetDataBulk,
    setAssetDataBulk,
    handleSelectAssetPreset,
    validateMessages,
    renderOption,
    alertPresetColumns,
    maintenanceRulesColumns,
    initialize
  } = props;

  console.log('assetDataBulk', assetDataBulk);

  const [bulkAssetForm] = Form.useForm();
  const [fileHandler] = useFileUpload();
  const [customFields, setCustomFields] = useState<CustomFieldType[]>([]);
  const { getCustomFields, FormItemField } = CustomField

  const BIZ_CODE = getBizCode()

  const setIsGlobalLoading = useGeneralStore((state: GeneralStore) => state.setIsGlobalLoading)

  useEffect(() => {
    if (isModalOpenBulk) {
      const customFields = getCustomFields(assetDataBulk?.custom_attributes)
      setCustomFields(customFields)
    }

    bulkAssetForm.setFieldsValue({ ...assetDataBulk })

  }, [isModalOpenBulk, assetDataBulk])

  const handleBulkConfirm = async (values: any) => {
    // need to get the form value and asset data default value in the payload
    const { quantity, email_results, bulkCsvFile, asset_acquisition_date, asset_price, home_location, predicted_end_of_life } = values
    const { masterData_refID } = assetDataBulk
    delete values.bulkCsvFile

    let existing_feilds = false
    let csv_s3url = ""
    const promList: any[] = [];
    if (bulkCsvFile) {
      if (bulkCsvFile.type && !bulkCsvFile.type.includes("csv")) {
        message.warning('Please upload csv file.')
        return
      }
      existing_feilds = true

      //csv_s3url as a file name
      csv_s3url = `${bulkCsvFile.name}`
      const curkey = fileHandler.constructS3Key(fileHandler.S3_MODULE_CODE.am, `asset_Preset/${masterData_refID}/${csv_s3url}`)
      console.log('fileName', curkey, csv_s3url)
      const logoProm = await fileHandler.uploadFileToS3(bulkCsvFile, curkey)
      console.log('logoProm', logoProm)
      promList.push(logoProm);
    }


    // get the custom attributes values
    const attributeObj: { [key: string]: any } = CustomField.getCustomAttributeObj(assetDataBulk.custom_attributes, values)

    // upload files from custom filed
    // TODO: handle no asset id - use master data id
    await CustomField.uploadFilesToS3(assetDataBulk.custom_attributes, 'asset_tracking', masterData_refID, attributeObj, values)


    const payload: any = {
      master_refID: masterData_refID,
      quantity,
      existing_feilds,
      csv_s3url,
      // has csv , use the form email_results, otherwise set empty
      email_results: csv_s3url !== "" ? email_results : "",
      custom_attributes: { ...attributeObj },
      asset_price,
      asset_acquisition_date: convertDateAndTime(asset_acquisition_date),
      predicted_end_of_life: convertDateAndTime(predicted_end_of_life),
      home_location
    }

    console.log('submit bulk asset payload', payload)

    Promise.all(promList).then((res) => {
      // setIsLoading(true)
      setIsGlobalLoading(true)

      const url = `${BIZ_CODE}/bulk_assets`
      ASSET_MANAGEMENT_API({
        url,
        method: 'POST',
        data: {
          ...payload
        }
      }).then(res => {

        closeBulkAssetPopUp()
        message.success('Assets added successfully!')
        // setIsLoading(false)
        setIsGlobalLoading(false)
        initialize()

      }).catch(err => {
        // setIsLoading(false)
        setIsGlobalLoading(false)
        message.error('Failed to add assets, please try again.')

      })
    }).catch((err) => {
      message.error('Something went wrong.')
      // setIsLoading(false)
      setIsGlobalLoading(false)
    });

  }

  const closeBulkAssetPopUp = (e?: MouseEvent) => {
    if (e) {
      e.preventDefault()
    }

    setIsModalOpenBulk(false);
    setAssetDataBulk(emptyAssetDataBulk)
    bulkAssetForm.resetFields()
    bulkAssetForm.setFieldsValue(emptyAssetDataBulk)
  };

  const handleUpdateQuantity = (file: RcFile, fileList?: RcFile[]) => {
    let assetQuantity = 0
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data: string = e?.target?.result;
      const lines = data.split('\n');
      console.log('csv lines: ', lines)
      lines.forEach((line: any) => {
        if (line != "") {
          assetQuantity = assetQuantity + 1
        }

      });
      assetQuantity = assetQuantity - 1
      const curFormValues = bulkAssetForm.getFieldsValue()
      const updatedValues = { ...curFormValues, quantity: String(assetQuantity) }
      bulkAssetForm.setFieldsValue(updatedValues)

    };
    reader.readAsBinaryString(file);

    return false
  }

  return (
    <GlobalModal
      title="Add Bulk Assets"
      open={isModalOpenBulk}
      onCancel={closeBulkAssetPopUp}
      large
      footer={[
        <FlexBox style={{ justifyContent: 'flex-end', marginTop: '0' }} key='1'>
          <SimpleButton
            id='modal-btn-width-regular'
            isCancel
            text="Cancel"
            style={{ marginRight: '1rem' }}
            onClick={(e: MouseEvent) => closeBulkAssetPopUp(e)}
          />
          <SimpleButton id='modal-btn-width-regular' htmlType="submit" form='bulkAssetForm' text="Add" />
        </FlexBox>
      ]}
    >
      <Form
        form={bulkAssetForm}
        name="bulkAssetForm"
        onFinish={(values: any) => handleBulkConfirm(values)}
        validateMessages={validateMessages}
        initialValues={{ ...assetDataBulk }}
      >
        <LabelDivider title="Asset Info" />
        <Row gutter={[15, 0]}>
          <Col xs={{ span: '24' }} md={{ span: '7' }} sm={{ span: '12' }}>
            <Form.Item
              name="masterData_refID"
              rules={[{ required: true, message: 'Please select your master data name' }]}
            >
              <Input
                label="Asset Preset"
                placeholder="Asset Preset"
                name="masterData_refID"
                type="select"
                options={renderOption('asset_presets')}
                required={true}
                value={assetDataBulk.masterData_refID}
                onChange={(value: string) => handleSelectAssetPreset(value, true)}
              />

            </Form.Item>
          </Col>
          {assetDataBulk.masterData_refID.length > 0 && (
            <>
              <Col md={{ span: 7 }} sm={{ span: 14 }} xs={{ span: 24 }}>
                <Form.Item
                  style={{}}
                  name="asset_category"
                  initialValue={assetDataBulk.asset_category}
                >
                  <Input
                    label="Asset Category"
                    name="asset_category"
                    type="text"
                    required={true}
                    value={assetDataBulk.asset_category}
                    disabled={true}
                  />

                </Form.Item>
              </Col>
              <Col md={{ span: 7 }} sm={{ span: 14 }} xs={{ span: 24 }}>
                <Form.Item
                  style={{}}
                  name="asset_type"
                  initialValue={assetDataBulk.asset_type}

                >
                  <Input
                    label="Asset Type"
                    name="asset_type"
                    type="text"
                    required={true}
                    value={assetDataBulk.asset_type}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col md={{ span: 7 }} sm={{ span: 14 }} xs={{ span: 24 }}>
                <Form.Item
                  name="asset_price"
                  rules={[{ required: true, message: 'Please input your asset value' }]}
                >
                  <Input
                    label="Asset Value (AUD)"
                    placeholder={'Asset Value'}
                    name="asset_price"
                    type="text"
                    required={true}
                  />

                </Form.Item>
              </Col>
              <Col md={{ span: 7 }} sm={{ span: 14 }} xs={{ span: 24 }}>
                <Form.Item
                  name="asset_acquisition_date"
                  rules={[{ required: true, message: 'Please select a Asset Acquisition Date' }]}
                >
                  <Input
                    label="Asset Acquisition Date"
                    placeholder={'Asset Acquisition Date'}
                    name="asset_acquisition_date"
                    type="date"
                    required={true}
                  />

                </Form.Item>
              </Col>
              <Col md={{ span: 7 }} sm={{ span: 14 }} xs={{ span: 24 }}>
                <Form.Item
                  name="predicted_end_of_life"
                >
                  <Input
                    label="Predicted End of Life"
                    placeholder={'Predicted End of Life'}
                    name="predicted_end_of_life"
                    type="date"
                  />

                </Form.Item>
              </Col>


            </>

          )}
        </Row>

        {assetDataBulk.masterData_refID.length > 0 &&
          <>
            <LabelDivider title="Asset Identification" />
            <Row gutter={[15, 0]} style={{ marginTop: '10px' }}>
              <Col md={{ span: '12' }} sm={{ span: '24' }} style={{ marginBottom: '15px' }}>
                <DragFileInput
                  useFormItem
                  label="Asset Names & ID's"
                  supportedFileText="(Supported Files: CSV)"
                  accept=".csv"
                  formItemProps={{
                    style: { marginBottom: 0 },
                    name: 'bulkCsvFile',
                  }}
                  beforeUpload={handleUpdateQuantity}
                />
              </Col>
              <Col md={{ span: '12' }} sm={{ span: '24' }} style={{ marginBottom: '15px' }}>
                <DisplayPanel />
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 7 }} sm={{ span: 14 }} xs={{ span: 24 }} style={{ padding: '0 7.5px' }}>
                <Form.Item
                  name="quantity"
                  rules={[{ required: true, message: 'Please select your master data name' }]}
                  style={{}}
                >
                  <Input
                    label="Asset Quantity"
                    placeholder="Enter Quantity"
                    name="quantity"
                    type="number"
                    required={true}
                    value={assetDataBulk.quantity}
                    min={1}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row style={{ alignItems: 'center' }}>
              <Col md={{ span: '12' }} sm={{ span: '24' }} style={{ marginBottom: '15px', padding: '0 7.5px' }}>
                <Form.Item
                  name="email_results"
                  rules={[{ type: 'email' }]}
                  style={{ flex: 1 }}
                >
                  <Input
                    name='email_results'
                    label='Email'
                    placeholder="Enter Email"
                    type="text"
                  />
                </Form.Item>

              </Col>
              <Col md={{ span: '12' }} sm={{ span: '24' }} style={{ padding: '0 7.5px' }}>
                <p style={{ color: 'var(--white-text-color)', fontSize: '12px' }}>
                  Provide the Email-Id to send the CSV after mapping the asset data.
                </p>
              </Col>


            </Row>
            <LabelDivider title="Maintenance Preset" />
            {assetDataBulk.maintenance_rules && (
              <div style={{ marginTop: '-3rem', maxWidth: '100%', overflowX: 'auto', marginBottom: '1.5rem' }}>
                <AdiTable
                  tableData={assetDataBulk.maintenance_rules}
                  columns={maintenanceRulesColumns}
                  noPagination={true}
                />
              </div>
            )}

            <LabelDivider title="Alert Preset" style={{ marginTop: '30px' }} />
            {assetDataBulk.alerts && (
              <div style={{ marginTop: '-3rem', maxWidth: '100%', overflowX: 'auto' }}>
                <AdiTable
                  tableData={assetDataBulk.alerts}
                  columns={alertPresetColumns}
                  noPagination={true}
                />
              </div>

            )}

            {
              customFields.length > 0 &&
              <LabelDivider title="Custom Fields" style={{ marginTop: '30px' }} />
            }
            <Row gutter={[15, 0]}>
              {
                customFields.filter((item: any) => item.fieldType !== 'bool' && item.fieldType !== 'doc')
                  .map((item: any, index: number) => {
                    console.log('customFields item', item)
                    return (
                      <Col md={{ span: 7 }} sm={{ span: 14 }} xs={{ span: 24 }} key={index}>
                        <FormItemField
                          fieldValues={item}
                        />
                      </Col>
                    )
                  }
                  )
              }
            </Row>
            <Row gutter={[15, 10]}>
              {
                customFields.filter((item: any) => item.fieldType === 'bool' || item.fieldType === 'doc')
                  .map((item: any, index: number) => {
                    return (
                      <Col span='24' key={index}>
                        <FormItemField
                          fieldValues={item}
                        />
                      </Col>
                    )
                  }
                  )
              }
            </Row>
          </>
        }

      </Form>
    </GlobalModal>
  )
}

export default BulkAssetModal


const DisplayPanel = () => {
  return (
    <DisplayPanelWrapper>
      <div className="upper">
        <InfoIcon />
        <p>
          Asset ID's are auto-generated and Assets will be auto-named unless specified.
        </p>
      </div>
      <div className="lower">
        {/* TODO: replace with the static csv file for acg only? */}
        <a target="_blank" href={`${process.env.REACT_APP_CDN_DEV}am/BulkAssetTemplate.csv`} rel="noreferrer">
          <DownloadCSVText>
            Download CSV Template
          </DownloadCSVText>
        </a>
        <p>
          Use the CSV Template to fill the Asset Data (Names & Existing ID's) to maintain consistent names to your assets and have a reference to existing ID's. Avoid any duplicate entry.
        </p>
      </div>
    </DisplayPanelWrapper>
  )
}

const LabelDivider = ({ title, style }: { title: string, style?: any }) => {
  return (
    <Divider orientation="left" orientationMargin="0" style={style}>
      <div style={{ fontSize: '14px' }}>{title}</div>
    </Divider>
  )
}

const DisplayPanelWrapper = styled.div`
  padding: 20px 40px 10px 50px;
  // background-color: #2A2A2A;
  background-color: #32334D;
  border-radius: var(--border-radius);
  position: relative;
  height: 100%;

  .upper {    
    p {
      color: var(--white-text-color);
      font-size: 12px;
      margin-bottom: 2rem;
    }
  }

  .lower {
    p {
      color: var(--white-text-color);
      font-size: 12px;
    }
  }
`

const DownloadCSVText = styled.p`
  color: var(--primary-color) !important;
  font-size: 14px !important;
`

const InfoIcon = styled(InfoCircleOutlined)`
  position: absolute;
  left: 10px;
  top: 20px;
  font-size: 25px;
  background-color: #b9b9b9;
  border-radius: 50%;
`